import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { useDatePickerContext } from "../AvailabilityPage/context/DatePickerContext";
import styles from "./HotelListEndOfResults.module.scss";
import { ActionButton } from "@/components/ActionButton";

export const HotelListEndOfResults = ({
  className,
  children,
}: PlatformComponentProps) => {
  const COMPONENT_KEY = "HotelListEndOfResults";
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();
  const { openDatePicker } = useDatePickerContext();

  const title = t("core-hotels.availabilityPage.results.endOfResults.title");

  const subtitle = t(
    "core-hotels.availabilityPage.results.endOfResults.subtitle"
  );

  return (
    <div className={clsx(block, className)}>
      <div className={cn("title")}>{title}</div>
      <div className={cn("subtitle")}>{subtitle}</div>
      <ActionButton
        message={t(
          "core-hotels.availabilityPage.results.noResults.changeDates"
        )}
        onClick={openDatePicker}
      />
      {children}
    </div>
  );
};
